import {
  GetStateResponse,
  getUserState,
  setUserState,
} from "../../api/userStateApi";
import { RokaState } from "../../types/rokaTypes";
import { useFetchWithToken } from "../utility-hoks/useFetchWithToken";

export const useSettingsApi = () => {
  const { fetchWithToken } = useFetchWithToken();

  const fetchState = async (): Promise<RokaState> => {
    const response = await fetchWithToken(getUserState());
    const parsedResponse = (await response.json()) as GetStateResponse;

    return {
      resetTime: parsedResponse.body.reset_time,
    };
  };

  const updateState = async (state: RokaState) => {
    await fetchWithToken(setUserState(state));
  };

  return {
    fetchState,
    updateState,
  };
};
